import React from 'react';
import { Check } from 'lucide-react';

/**
 * Modern Wizard Progress Bar with Glassmorphism
 * Build: 2026-01-15
 */
function WizardProgressBar({ currentStep }) {
  const steps = [
    { number: 1, label: 'Job Details' },
    { number: 2, label: 'Questions' },
    { number: 3, label: 'Generate' },
    { number: 4, label: 'Review' }
  ];

  const getStepStatus = (step) => {
    if (step.number < currentStep) return 'completed';
    if (step.number === currentStep) return 'current';
    return 'upcoming';
  };

  return (
    <div className="mb-8 bg-white/80 backdrop-blur-md border border-white/30 rounded-2xl p-6 shadow-lg animate-slideIn">
      <div className="flex items-center justify-between max-w-3xl mx-auto">
        {steps.map((step, index) => {
          const status = getStepStatus(step);
          return (
            <React.Fragment key={step.number}>
              <div className="flex flex-col items-center flex-1">
                <div
                  className={`
                    w-12 h-12 rounded-full flex items-center justify-center font-black text-base mb-2
                    transition-all duration-300 motion-reduce:transition-none shadow-lg scale-110
                    ${status === 'completed'
                      ? 'bg-primary text-white'
                      : status === 'current'
                      ? 'bg-primary text-white ring-4 ring-primary/20'
                      : 'bg-slate-200 text-slate-400'
                    }
                  `}
                >
                  {status === 'completed' ? <Check size={24} /> : step.number}
                </div>
                <div
                  className={`
                    text-xs font-semibold text-center transition-colors duration-200
                    ${status === 'completed' || status === 'current'
                      ? 'text-slate-900'
                      : 'text-slate-400'
                    }
                  `}
                >
                  {step.label}
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="flex-1 h-1 mx-2 mb-8 bg-slate-200 rounded-full overflow-hidden">
                  <div
                    className={`
                      h-full transition-all duration-500 ease-out
                      ${step.number < currentStep ? 'w-full bg-primary' : 'w-0 bg-slate-200'}
                    `}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default WizardProgressBar;
